import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { openCookieSettings } from "@/lib/consent";

export default function Footer() {
  return (
    <footer className="bg-[#1A2433] text-slate-200 mt-24" data-testid="site-footer">
      <div className="mbw-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white p-2 rounded-lg">
              <img src="/assets/mbw-logo-icon.png" alt="MBW Swiss AG Logo" className="w-14 h-14 object-contain" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-[#DC2626] text-xl">MBW Swiss AG</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-300 font-semibold">
                Treuhand · Steuern · Firmengründung
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-md">
            Beratung für Sie – alles aus einer Hand vor Ort. Steuerberatung, Treuhand,
            Firmengründungen und Vorratsgesellschaften in der Schweiz, speziell für
            Kundinnen und Kunden aus dem deutschsprachigen Raum.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-white font-semibold mb-4">Leistungen</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/leistungen#firmenansiedlung" className="hover:text-[#DC2626]">Firmenansiedlungen</Link></li>
            <li><Link to="/leistungen#gruendung" className="hover:text-[#DC2626]">Gesellschaftsgründung</Link></li>
            <li><Link to="/leistungen#vr" className="hover:text-[#DC2626]">Verwaltungsmandate</Link></li>
            <li><Link to="/leistungen#buchhaltung" className="hover:text-[#DC2626]">Finanzbuchhaltung</Link></li>
            <li><Link to="/leistungen#steuern" className="hover:text-[#DC2626]">Steuerberatung</Link></li>
            <li><Link to="/vorratsgesellschaften" className="hover:text-[#DC2626]">Vorratsgesellschaften</Link></li>
            <li><Link to="/preisliste" className="hover:text-[#DC2626]">Preisliste 2025</Link></li>
            <li><Link to="/so-funktionierts" className="hover:text-[#DC2626]">So funktioniert's</Link></li>
            <li><Link to="/empfehlen" className="hover:text-[#DC2626]">Empfehlungsprogramm</Link></li>
            <li><Link to="/rechner" className="hover:text-[#DC2626]">Kostenrechner</Link></li>
            <li><Link to="/downloads" className="hover:text-[#DC2626]">Downloads</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white font-semibold mb-4">Kontakt</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 text-[#DC2626] mt-0.5" />
              <a href="tel:+41525510140" className="hover:text-white">+41 52 551 01 40</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 text-[#DC2626] mt-0.5" />
              <a href="mailto:office@mbw-swiss.ch" className="hover:text-white">office@mbw-swiss.ch</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-[#DC2626] mt-0.5" />
              <span>Wildenstrasse 3<br />8212 Neuhausen am Rheinfall</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mbw-container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} MBW Swiss AG. Alle Rechte vorbehalten.</div>
          <div className="flex gap-5 flex-wrap">
            <Link to="/impressum" className="hover:text-slate-300">Impressum</Link>
            <Link to="/impressum#agb" className="hover:text-slate-300">AGB</Link>
            <Link to="/datenschutz" className="hover:text-slate-300">Datenschutz</Link>
            <button
              type="button"
              onClick={() => openCookieSettings()}
              className="hover:text-slate-300 underline-offset-2"
              data-testid="footer-cookie-settings"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
